import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposCentrosCosto } from 'constants/index'

const TipoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='input-tipo' md={4} alignRightAt='md' />
      <Col md={8}>
        {TiposCentrosCosto.__array.map(x => (
          <Field name='tipo'>
            {({ field }) => (
              <Form.Radio {...field} value={x.id} disabled={fIsSubmitting} id={`input-tipo-${x.id}`} label={x.nombre} checked={iValue === x.id} />
            )}
          </Field>
        ))}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
